export class PasswordGeneratorOptions {
}
export var PasswordGeneratorCharGroupTypes;
(function (PasswordGeneratorCharGroupTypes) {
    PasswordGeneratorCharGroupTypes[PasswordGeneratorCharGroupTypes["Digits"] = 0] = "Digits";
    PasswordGeneratorCharGroupTypes[PasswordGeneratorCharGroupTypes["LowerCaseLetters"] = 1] = "LowerCaseLetters";
    PasswordGeneratorCharGroupTypes[PasswordGeneratorCharGroupTypes["UpperCaseLetters"] = 2] = "UpperCaseLetters";
    PasswordGeneratorCharGroupTypes[PasswordGeneratorCharGroupTypes["SpecialChars"] = 3] = "SpecialChars";
    PasswordGeneratorCharGroupTypes[PasswordGeneratorCharGroupTypes["CustomChars"] = 4] = "CustomChars";
})(PasswordGeneratorCharGroupTypes || (PasswordGeneratorCharGroupTypes = {}));
export class PasswordGeneratorCharGroup {
    constructor(type, chars) {
        this.type = type;
        this.chars = chars;
    }
}
PasswordGeneratorCharGroup.DIGITS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
PasswordGeneratorCharGroup.LOWER_CASE_LETTERS = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
PasswordGeneratorCharGroup.UPPER_CASE_LETTERS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
// https://owasp.org/www-community/password-special-characters: " !\"#$%&'()*+,-./:;<=>?@[\]^_`{|}~" (excluded: [space], `, \, ', ")
PasswordGeneratorCharGroup.SPECIAL_CHARS = ["!", "#", "$", "%", "&", "(", ")", "*", "+", ",", "-", ".", "/", ":", ";", "<", "=", ">", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"];
export class PasswordGenerator {
    constructor(random) {
        this.random = random;
    }
    generate(charGroups, length, options) {
        let chars = [];
        let everyGroupChars = [];
        let customCharGroup = null;
        charGroups.forEach((grp) => {
            if (grp.type === PasswordGeneratorCharGroupTypes.CustomChars) {
                customCharGroup = grp;
                return;
            }
            chars = chars.concat(grp.chars);
            if (options.useEveryGroup) {
                everyGroupChars.push(this.random.randomArrayItem(grp.chars));
            }
        });
        if (customCharGroup !== null) {
            // filter out all existing chars to prevent duplicates
            const customCharGroupChars = customCharGroup.chars.filter(char => chars.indexOf(char) === -1);
            chars = chars.concat(customCharGroupChars);
            if (options.useEveryGroup) {
                everyGroupChars.push(this.random.randomArrayItem(customCharGroupChars));
            }
        }
        let overwriteChars = {};
        if (everyGroupChars.length > 0) {
            let i = 0;
            let overwriteKeys = Array(length).fill(0, 0, length).map(() => { return i++; });
            everyGroupChars.forEach((char) => {
                const randomOverwriteKey = this.random.randomArrayItem(overwriteKeys);
                overwriteKeys = overwriteKeys.filter(i => i !== randomOverwriteKey);
                overwriteChars[randomOverwriteKey] = char;
            });
        }
        return this.random.generate(chars, length, overwriteChars);
    }
}
